/**
 * Tiny mutation helper for POST/PUT/DELETE. Callers pass an imperative
 * function that returns a promise; this tracks loading/error so forms
 * can disable submit buttons cleanly.
 */
import { useCallback, useState } from 'react'

export function useMutation(fn) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const mutate = useCallback(
    async (...args) => {
      setLoading(true)
      setError(null)
      try {
        return await fn(...args)
      } catch (err) {
        setError(err)
        throw err
      } finally {
        setLoading(false)
      }
    },
    [fn]
  )

  return { mutate, loading, error }
}
